import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Article Type Superiors',
  basePath: '/articletype-superior',
  rowKey: 'pid',
  reorderable: true,
  columns: [
    { key: 'title', label: 'Title' },
    { key: 'router_link_label', label: 'Router Link' },
    { key: 'active', label: 'Active',
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'superior_id', label: 'Article Superior', type: 'async-select',
      optionsUrl: '/article-superiors/options' },
    { key: 'title', label: 'Title', type: 'text',
      fieldInfo: 'Title of article superior for the country' },
    { key: 'router_link', label: 'Link', type: 'async-select',
      optionsUrl: '/router-links/options' },
    { key: 'active', label: 'Active', type: 'yesno', defaultValue: '0' },
    { key: 'category_title', label: 'Category Title', type: 'text' },
    { key: 'category_intro', label: 'Category Intro', type: 'text' },
    { key: 'category_description', label: 'Category Description', type: 'rich-text' },
  ],
  rowActions: [{ key: 'edit', label: 'Edit' }],
});
